import * as React from 'react';
import { Grow } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import { getBusinessThumbnailSrc } from 'utils/businessUtils';
import { useMountEffect } from '@tock/hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'none',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    content: {
      alignSelf: 'center',
      flex: 1,
    },
    thumb: {
      borderRadius: theme.borderRadius[100],
      marginLeft: theme.spacing(1),
    },
  })
);

interface Props {
  business: consumer.BusinessConfig;
  showBusinessCard?: boolean;
}

export const ReservationSearchBarCard: React.FunctionComponent<Props> = ({
  business,
  showBusinessCard,
}) => {
  const classes = useStyles();

  const imgSrc = getBusinessThumbnailSrc(business, { height: 70, width: 70 });

  useMountEffect(() => {
    if (typeof window !== `undefined`) {
      const img = new Image();
      img.src = imgSrc;
    }
  });

  const businessSubtitle = business
    ? [business.cuisines, business.priceRange].filter(Boolean).join(' · ')
    : '';
  if (!showBusinessCard) {
    return null;
  }
  return (
    <Grow in={true}>
      <section className={classes.root}>
        <section className={classes.content}>
          <Typography component="h3" variant="heading03">
            {business.name}
          </Typography>
          <Typography variant="body02">{businessSubtitle}</Typography>
        </section>
        {imgSrc && (
          <img className={classes.thumb} loading="eager" src={imgSrc} alt={business.name} />
        )}
      </section>
    </Grow>
  );
};
